<template>
    <section class="orderInfo">
		<van-nav-bar title="订单详情" left-arrow @click-left="backFn" class="top_bar" />	
		<section v-if="info.id">
			<section class="order_card">
				<div class="inform">
					<img src="../../assets/img/laba.png">
					未经客户同意不得向第三方提供个人信息，违反者永久封禁账号，并承担相应法律责任
				</div>
				<div class="card">
					<img src="../../assets/img/info_dianhe.png" class="dianhe" v-if="isDianhe">
					<div class="name">
						<p class="txt">{{info.basicInfo.name}}</p>
						<!-- <img src="../../assets/img/star45.png" class="star"> -->
						<img src="../../assets/img/discounts.png" class="discounts" v-if="info.typeOfSales == 1">
						<img src="../../assets/img/good.png" class="sign" v-else>
						<p class="discounts_num" v-if="info.typeOfSales == 1">{{(info.discountRate*10).toFixed(2)}}折</p>
					</div>
					<div class="date">
						申请时间 {{info.createTime}}
					</div>
					<div class="card_num">
						<div class="money">
							<p>{{info.loanInfo.loanAmount}}<span>万</span></p>
							<p>金额</p>
						</div>
						<div class="money time">
							<p>{{info.loanInfo.loanTerm}}<span>个月</span></p>
							<p>期限</p>
						</div>
						<div class="money">
							<p>{{info.loanInfo.loanPurposeName}}</p>
							<p>目的</p>
						</div>
					</div>
				</div>
			</section>
			<section class="order_form">
				<div class="base_info">
					<div class="tit">
						<p>
							基础信息
							<img src="../../assets/img/tit_line.png">
						</p>
					</div>
					<p class="item" v-if="info.basicInfo.age">
						<span>年龄</span>
						<span>{{info.basicInfo.age}}</span>
					</p>
					<p class="item" v-if="info.basicInfo.gender && (info.basicInfo.gender<=3||info.basicInfo.gender=='认证后可见')">
						<span>性别</span>
						<span v-if="info.basicInfo.gender==1">男</span>
						<span v-else-if="info.basicInfo.gender==2">女</span>
						<span v-else-if="info.basicInfo.gender==3">未知</span>
						<span v-else>{{info.basicInfo.gender}}</span>
					</p>
					<p class="item" v-if="isApprove">
						<span>居住城市</span>
						<span>{{cityStr}}</span>
					</p>
					<p class="item" v-else>
						<span>居住城市</span>
						<span>认证后可见</span>
					</p>
				</div>
				<div class="base_info" v-if="info.productName && info.distributionChannel">
					<div class="tit">
						<p>
							渠道信息
							<img src="../../assets/img/tit_line.png">
						</p>
					</div>
					<p class="item" v-if="info.productName">
						<span>产品名称</span>
						<span>{{info.productName}}</span>
					</p>
					<p class="item" v-if="info.distributionChannel">
						<span>投放渠道</span>
						<span>{{info.distributionChannel}}</span>
					</p>
				</div>
				<div class="work_info">
					<div class="tit">
						<p>
							工作信息
							<img src="../../assets/img/tit_line.png">
						</p>
					</div>
					<p class="item" v-if="info.workInfo.professionStr">
						<span>职业身份</span>
						<span>{{info.workInfo.professionStr}}</span>
					</p>
					<p class="item" v-if="info.workInfo.income">
						<span>月收入</span>
						<span v-if="info.workInfo.income=='认证后可见'">{{info.workInfo.income}}</span>
						<span v-else>{{info.workInfo.income}}元</span>
					</p>
					<p class="item" v-if="info.workInfo.formOfIncome">
						<span>工资发放形式</span>
						<span v-if="info.workInfo.formOfIncome=='认证后可见'">认证后可见</span>
						<span v-else>
							<i v-if="info.workInfo.formOfIncome==1">银行卡</i>
							<i v-else-if="info.workInfo.formOfIncome==2">现金</i>
							<i v-else-if="info.workInfo.formOfIncome==3">自存</i>
						</span>
					</p>
					<p class="item" v-if="info.workInfo.socialStatus && (info.workInfo.socialStatus<=3||info.workInfo.socialStatus=='认证后可见')">
						<span>社保</span>
						<span v-if="info.workInfo.socialStatus == 1">
							<i v-if="info.workInfo.socialDetail==1">未满6个月</i>
							<i v-else-if="info.workInfo.socialDetail==2">6个月以上</i>
							<i v-else>有</i>
						</span>
						<span v-else-if="info.workInfo.socialStatus == 2">无</span>
						<span v-else-if="info.workInfo.socialStatus==3">未知</span>
						<span v-else>认证后可见</span>
					</p>
					<p class="item" v-if="info.workInfo.fundStatus && (info.workInfo.fundStatus<=3||info.workInfo.fundStatus=='认证后可见')">
						<span>公积金</span>
						<span v-if="info.workInfo.fundStatus == 1">
							<i v-if="info.workInfo.fundDetail==1">未满6个月</i>
							<i v-else-if="info.workInfo.fundDetail==2">6个月以上</i>
							<i v-else>有</i>
						</span>
						<span v-else-if="info.workInfo.fundStatus == 2">无</span>
						<span v-else-if="info.workInfo.fundStatus==3">未知</span>
						<span v-else>认证后可见</span>
					</p>
				</div>
				<div class="money_info" v-if="isShowAssets">
					<div class="tit">
						<p>
							资产信息
							<img src="../../assets/img/tit_line.png">
						</p>
					</div>
					
					<p class="item" v-if="info.assetInfo.creditCardStatus && (info.assetInfo.creditCardStatus<=3||info.assetInfo.creditCardStatus=='认证后可见')">
						<span>信用卡额度</span>
						<span v-if="info.assetInfo.creditCardStatus == 1">
							<i v-if="info.assetInfoDetail.creditCardDetail==1">3000元以下</i>
							<i v-else-if="info.assetInfoDetail.creditCardDetail==2">3000-1万元</i>
							<i v-else-if="info.assetInfoDetail.creditCardDetail==3">1-3万元</i>
							<i v-else-if="info.assetInfoDetail.creditCardDetail==4">3万元以上</i>
							<i v-else>有</i>
						</span>
						<span v-else-if="info.assetInfo.creditCardStatus == 2">无</span>
						<span v-else-if="info.assetInfo.creditCardStatus==3">未知</span>
						<span v-else>认证后可见</span>
					</p>
					
					<p class="item" v-if="info.assetInfo.jieBeiStatus && (info.assetInfo.jieBeiStatus<=3||info.assetInfo.jieBeiStatus=='认证后可见')">
						<span>借呗额度</span>
						<span v-if="info.assetInfo.jieBeiStatus == 1">
							<i v-if="info.assetInfoDetail.jieBeiDetail==1">3000元以下</i>
							<i v-else-if="info.assetInfoDetail.jieBeiDetail==2">3000-1万元</i>
							<i v-else-if="info.assetInfoDetail.jieBeiDetail==3">1-3万元</i>
							<i v-else-if="info.assetInfoDetail.jieBeiDetail==4">3万元以上</i>
							<i v-else>有</i>
						</span>
						<span v-else-if="info.assetInfo.jieBeiStatus == 2">无</span>
						<span v-else-if="info.assetInfo.jieBeiStatus==3">未知</span>
						<span v-else>认证后可见</span>
					</p>
					<p class="item" v-if="info.assetInfo.particleLoanStatus && (info.assetInfo.particleLoanStatus<=3||info.assetInfo.particleLoanStatus=='认证后可见')">
						<span>微粒贷额度</span>
						<span v-if="info.assetInfo.particleLoanStatus == 1">
							<i v-if="info.assetInfoDetail.particleLoanDetail==1">3000元以下</i>
							<i v-else-if="info.assetInfoDetail.particleLoanDetail==2">3000-1万元</i>
							<i v-else-if="info.assetInfoDetail.particleLoanDetail==3">1-3万元</i>
							<i v-else-if="info.assetInfoDetail.particleLoanDetail==4">3万元以上</i>
							<i v-else>有</i>
						</span>
						<span v-else-if="info.assetInfo.particleLoanStatus == 2">无</span>
						<span v-else-if="info.assetInfo.particleLoanStatus==3">未知</span>
						<span v-else>认证后可见</span>
					</p>

					<p class="item" v-if="info.assetInfoDetail.sesameStatus && (info.assetInfoDetail.sesameStatus<=3||info.assetInfoDetail.sesameStatus=='认证后可见')">
						<span>芝麻分</span>
						<span v-if="info.assetInfoDetail.sesameStatus == 1">
							<i v-if="info.assetInfoDetail.sesameDetail==1">600分以下</i>
							<i v-else-if="info.assetInfoDetail.sesameDetail==2">600-650分</i>
							<i v-else-if="info.assetInfoDetail.sesameDetail==3">650-700分</i>
							<i v-else-if="info.assetInfoDetail.sesameDetail==4">700分以上</i>
							<i v-else>有</i>
						</span>
						<span v-else-if="info.assetInfoDetail.sesameStatus == 2">无</span>
						<span v-else-if="info.assetInfoDetail.sesameStatus==3">未知</span>
						<span v-else>认证后可见</span>
					</p>
					<p class="item" v-if="info.assetInfo.houseStatus && (info.assetInfo.houseStatus<=3||info.assetInfo.houseStatus=='认证后可见')">
						<span>名下房产</span>
						<span v-if="info.assetInfo.houseStatus == 1">
							<i v-if="info.assetInfoDetail.houseDetail==1">有按揭房产</i>
							<i v-else-if="info.assetInfoDetail.houseDetail==2">有全款房产</i>
							<i v-else>有</i>
						</span>
						<span v-else-if="info.assetInfo.houseStatus == 2">无</span>
						<span v-else-if="info.assetInfo.houseStatus==3">未知</span>
						<span v-else>认证后可见</span>
					</p>
					<p class="item" v-if="info.assetInfo.carStatus && (info.assetInfo.carStatus<=3||info.assetInfo.carStatus=='认证后可见')">
						<span>名下车产</span>
						<span v-if="info.assetInfo.carStatus == 1">
							<i v-if="info.assetInfoDetail.carDetail==1">有按揭车产</i>
							<i v-else-if="info.assetInfoDetail.carDetail==2">有全款车产</i>
							<i v-else>有</i>
						</span>
						<span v-else-if="info.assetInfo.carStatus == 2">无</span>
						<span v-else-if="info.assetInfo.carStatus==3">未知</span>
						<span v-else>认证后可见</span>
					</p>
					<p class="item" v-if="info.assetInfo.insuranceStatus && (info.assetInfo.insuranceStatus<=3||info.assetInfo.insuranceStatus=='认证后可见')">
						<span>个人保险</span>
						<span v-if="info.assetInfo.insuranceStatus == 1">
							<i v-if="info.assetInfoDetail.insuranceDetail==1">缴纳未满1年</i>
							<i v-else-if="info.assetInfoDetail.insuranceDetail==2">缴纳1年以上</i>
							<i v-else>有</i>
						</span>
						<span v-else-if="info.assetInfo.insuranceStatus == 2">无</span>
						<span v-else-if="info.assetInfo.insuranceStatus==3">未知</span>
						<span v-else>认证后可见</span>
					</p>
					<p class="item" v-if="info.assetInfo.licenseStatus && (info.assetInfo.licenseStatus<=3||info.assetInfo.licenseStatus=='认证后可见')">
						<span>营业执照</span>
						<span v-if="info.assetInfo.licenseStatus == 1">
							<i v-if="info.assetInfoDetail.licenseDetail==1">注册未满1年</i>
							<i v-else-if="info.assetInfoDetail.licenseDetail==2">注册1-3年</i>
							<i v-else-if="info.assetInfoDetail.licenseDetail==3">注册3-5年</i>
							<i v-else-if="info.assetInfoDetail.licenseDetail==4">注册5年以上</i>
							<i v-else>有</i>
						</span>
						<span v-else-if="info.assetInfo.licenseStatus == 2">无</span>
						<span v-else-if="info.assetInfo.licenseStatus==3">未知</span>
						<span v-else>认证后可见</span>
					</p>
				</div>
			</section>
			<section v-if="!isShow"></section>
			<section v-else>
				<div class="bottom" v-if="!token">
					<van-button type="primary" @click="loginModelFn('login')">登录并认证，获取实时订单</van-button>
				</div>
				<div class="bottom" v-if="token && !isApprove">
					<van-button type="primary" @click="skipAttestation">认证后可购买</van-button>
				</div>
				<div class="buy_order" v-if="token && isApprove">
					<div class="price_num" :style="{'padding-left': info.typeOfSales == 1?'24px':'54px'}">
						<i v-if="info.typeOfSales == 1">{{info.originalPrice}}币</i>
						<p class="num">{{info.amount}}<span>币</span></p>
						<p class="sign" v-if="info.typeOfSales == 1"><span>{{(info.discountRate*10).toFixed(2)}}折</span></p>
					</div>
					<van-button type="primary" @click="buyFn">立即抢单</van-button>
				</div>
			</section>
			<!-- <Login :isLoginModel="isLoginModel" :type="type" :topLeftArrow="topLeftArrow" @closeModel="isLoginModel=false" @loginStatus="loginStatus" @loginModelFn="loginModelFn" /> -->
			<van-overlay :show="isOverlay" />
			<section class="dialog" :class="className" v-if="isDialog">
				<h4 v-if="isTitle">抢单</h4>
				<div class="primary" v-if="status==1">
					<p class="text">确认支付{{info.amount}}展业币购买此订单？</p>
				</div>
				<div class="primary" v-else-if="status==2">
					<p class="text">展业币可用余额不足，请充值</p>
				</div>
				<div class="primary_img_run" v-else-if="status==3">
					<img src="../../assets/img/order_run.png" alt="">
					<p>正在拼命抢单中…</p>
				</div>
				<div class="primary_img_fail" v-else-if="status==4">
					<img src="../../assets/img/order_fail.png" alt="">
					<p>手速慢，已被他人先接单<br>本次不会扣除展业币</p>
				</div>
				<div class="primary_img_success" v-else-if="status==5">
					<img src="../../assets/img/order_success.png" alt="">
					<p>恭喜你 抢单成功！</p>
				</div>
				<div class="footer" v-if="isFooter">
					<p class="left" v-if="cancelButtonText" @click="cannelFn(status)">{{cancelButtonText}}</p>
					<p class="right" v-if="confirmButtonText" @click="confirmFn(status)">{{confirmButtonText}}</p>
				</div>

			</section>
		</section>
		<section v-else>
		</section>




	</section>
</template>

<script>
import Nav from "components/Nav"
import Login from "components/Login";
import orderServer from "api/order";
import myServer from "api/my";
import { Notify, Dialog } from 'vant';


export default {
    name: "orderInfo",
	components: {
		Nav,
		Login,
	},
    data() {
        return {
			isShow: '',
			token: '',  //是否以登录
			isApprove: 0, //是否以认证
			balance: 0, //可用余额
			status: 5, //抢单弹框status
			baseNum: 1000000,
			cityStr: '',
			id: '',
			info: {
				loanInfo: {},
				workInfo:{},
				basicInfo: {},
				assetInfo:{},
				assetInfoDetail: {},
			},
			price: '',
			isLoginModel: false,
			topLeftArrow: true,
			type:'login',
			paddingLeft: 22,
			isTitle: '',
			isOverlay: false,
			isDialog: false,
			isFooter: false,
			confirmButtonText: '',
			cancelButtonText: '',
			className: '',  //primary_img_dialog_run, primary_img_dialog_success_fail
			isShowAssets: false,
			isDianhe: false,
		};
    },
    created() {
		this.id = this.$route.params.id
		this.token = localStorage.getItem('token')
		let position = localStorage.getItem('position')
		this.dataInit(position)
		
	},
    methods: {
		dataInit(position) {
			if(!this.token) {
				this.infoInit()
				this.isShow = 1
				this.isApprove = 0
				this.isShowAssets = true
				return
			}
			if(!position && this.token) {
				this.infoInit()
				this.isShow = 1
				this.isApprove = 0
				this.isShowAssets = true
				return
			}
			if(position && this.token) {
				this.getApproveStatus()
				this.getBalance()
				return
			}	
		},
		infoInit() {
			this.info = {
				id:1,
				amount: 0,
				createTime: this.timeInit(),
				productName: '认证后可见',
				distributionChannel: '认证后可见',
				loanInfo: {
					loanAmount: 20,
					loanTerm: 12,
					loanPurposeName: "",
				},
				workInfo:{
					city: '认证后可见',
					profession: '认证后可见',
					income: '认证后可见',
					fundStatus: '认证后可见',
					socialStatus: '认证后可见',
					professionStr: '认证后可见',
					formOfIncome: '认证后可见',
				},
				basicInfo: {
					name: '张先生',
					age: '认证后可见',
					gender: '认证后可见',
					channelCode: '',
				},
				assetInfo:{
					creditCardStatus: '认证后可见',
					jieBeiStatus: '认证后可见',
					particleLoanStatus: '认证后可见',
					houseStatus: '认证后可见',
					carStatus: '认证后可见',
					insuranceStatus: '认证后可见',
					licenseStatus: '认证后可见',
					sesameStatus: '认证后可见',
				},
				assetInfoDetail: {
					sesameStatus: '认证后可见'
				},
			}
			var arr = ['购物','旅游','教育','医疗','租房','其他']
			var index = Math.floor((Math.random()*arr.length));
			this.city = ['认证后可见','认证后可见']
			this.info.loanInfo.loanPurposeName = arr[index]
		},
		//获取当前日期
		timeInit() {
			var now = new Date();
			var month = now.getMonth() + 1;
			var day = now.getDate();
			if (month < 10) {
				month = "0" + month;
			}
			if (day < 10) {
				day = "0" + day;
			}
			let timeStr = now.getFullYear() + "-" + month + "-" + day
			return timeStr
		},
		getApproveStatus() {
			orderServer.AuthStatus().then((res) => {
				if(res.data.status == 20) {
					this.isApprove = 1
				}else {
					this.isApprove = 0
					this.infoInit()
				}
				this.getInfo()
			})
			
		},
		getBalance() {
			myServer.SearchWallet().then((res) => {
				this.balance = res.data.balance
			})
		},
		loginModelFn() {
			// 登录提示：抢单停止，改为推单模式
			Dialog.confirm({
				title: '提示',
				message: '抢单模式已停止。现变更为推单模式。如需开通推送账户，请扫码添加客服开通。',
				confirmButtonText: '联系客服',
				cancelButtonText: '确认',
			}).then(() => {
				this.$router.push({ name: 'kefu' })
			}).catch(() => {
				// 点击"确认"，仅关闭弹窗，终止后续流程
			})
		},

		loginStatus(status, newUser) {
			if(status == 'ok') {
				this.isLoginModel = false
				
			}
		},


		getInfo() {
			orderServer.SearchOrderInfo({id: this.id}).then((res) => {
				if (!res.data.loanInfo) {
					Notify({ type: 'danger', message: '意向单不存在' })
					return
				}
				if(res.data.labelList && res.data.labelList.indexOf('电核')!=-1) {
					this.isDianhe = true
				}
				if(this.isApprove) {
					this.info = res.data
					// cityStr
					if(res.data.workInfo.city) {
						if(res.data.workInfo.city) {
							if(res.data.workInfo.city.indexOf('-')!=-1) {
								let city = res.data.workInfo.city.split('-')
								this.cityStr = city[1]
							}else {
								this.cityStr = res.data.workInfo.city
							}
						}
					}
					this.info.amount = res.data.amount
					this.price = res.data.amount
					this.info.loanInfo.loanAmount = res.data.loanInfo.loanAmount/this.baseNum
					this.info.workInfo.income = res.data.workInfo.income/100
					for (let key in res.data.assetInfo) {
						if(res.data.assetInfo[key]) {
							this.isShowAssets = true
						}
					}

					if (res.data.assetInfoDetail["sesameStatus"]) {
						this.isShowAssets = true
					}
				}else {
					this.info.basicInfo.name = res.data.basicInfo.name
					this.info.loanInfo.loanPurposeName = res.data.loanInfo.loanPurposeName
					this.info.loanInfo.loanAmount = res.data.loanInfo.loanAmount/this.baseNum
					this.info.loanInfo.loanTerm = res.data.loanInfo.loanTerm
					this.info.createTime = res.data.createTime
					this.info.typeOfSales = res.data.typeOfSales
					this.info.discountRate = res.data.discountRate
					this.isShowAssets = true
				}
				this.isShow = 1
			})
		},
		buyFn() {
			this.status = 1
			this.confirmButtonText = '确定'
			this.cancelButtonText = '取消'
			this.isTitle = 1
			this.className = ''
			this.isFooter= true
			this.isOverlay = true
			this.isDialog = true
		},
		cannelFn(status) {
			
			if(status!=5) {
				this.isOverlay = false
				this.isDialog = false
			}else {
				this.$router.go(-1)
			}
		},
		confirmFn(status){
			if(status == 1) {
				if(this.balance< this.info.amount) {
					this.status = 2
					this.confirmButtonText = '去充值'
					this.cancelButtonText = '放弃抢单'
				}else {
					this.status = 3
					this.isTitle= false
					this.isFooter= false
					this.className = 'primary_img_dialog_run'
					orderServer.BuyOrder({requireId: this.id, amount: this.price}).then((res) => {
						if(res.code == 1) {
							this.status = 5
							this.isTitle= false
							this.confirmButtonText = '查看我的客户'
							this.cancelButtonText = '确定'
							this.isFooter= true
							this.className = 'primary_img_dialog_success_fail'
						}else if(res.code==22) {
							this.status = 4
							this.isTitle= false
							this.isFooter= true
							this.confirmButtonText = '确定'
							this.cancelButtonText = ''
							this.className = 'primary_img_dialog_success_fail'
						}else {
							this.isDialog = false
							this.isOverlay = false
							Notify({ type: 'danger', message: res.msg })
						}
					})
				}
			}else if(status == 2) {
				//跳转到充值页面
				this.fullFn()
			}else if(status == 4) {
				this.isOverlay = false
				this.isDialog = false
				this.$router.push({name: 'index'})
			} else if(status == 5) {
				this.$router.push({name: 'clientele'})
			}
		},
		backFn() {
			this.$router.push({name:'index'})
		},
		fullFn() {
			// orderServer.PostFull({skuId: this.info.id}).then((res) => {
				this.$router.push({name:'full'})
			// })
		},
		skipAttestation() {
			let position = localStorage.getItem('position')
			if(!position && this.token) {
				Dialog.confirm({
					title: '提示',
					message: '请先到首页完成位置选择',
					confirmButtonText: '知道了',
					cancelButtonText: '好的',
					closeOnClickOverlay: true,
				}).then(() => {
					this.$router.push({name: 'index'})
					// on confirm
				}).catch(() => {
				});
			}
			if(position && this.token) {
				this.$router.push({name: 'attestation'})
			}
		},

	},
};
</script>

<style lang="scss">
	.orderInfo {
		padding-top: 46px;
		padding-bottom: 100px;
		i {
			font-style: normal;
		}
		.order_card {
			height: 196px;
			background: linear-gradient(180deg, #3A5EEC 0%, #5575F5 56%, #F6F6F6 100%);
			.inform {
				padding: 6px 16px;
				position: relative;
				font-size: 14px;
				color: #3A5EEC;
				background: #CDEFFA;
				padding-left: 36px;
				margin-bottom: 23px;
				img {
					position: absolute;
					top: 11px;
					left: 15px;
					width: 16px;
				}
			}
			.card {
				position: relative;
				margin: 0 15px;
				height: 144px;
				// margin-top: 23px;
				background: linear-gradient(180deg, #E6E9ED 0%, #FFFFFF 100%);
				border-radius: 6px;
				border: 1Px solid #FFFFFF;
				padding: 9px 17px;
				.dianhe {
					position: absolute;
					bottom: 0;
					right: 0;
					width: 51px;
				}
				.name {
					position: relative;
					display: flex;
					align-items: center;
					.txt {
						color: #2C2D2F;
						font-size: 18px;
					}
					.discounts_num {
						position: absolute;
						top: -10px;
						right: -30px;
						// width: 57px;
						// height: 26px;
						// line-height: 26px;
						padding: 3px 5px;
						background: linear-gradient(41deg, #FFD049 0%, #FFB457 100%);
						box-shadow: 0px 0px 0px 0px #FFC06F;
						color: #FC0E2D;
						font-size: 15px;
						font-weight: bold;
						text-align: center;
						border-radius: 30px;
						border-bottom-left-radius: 0;
						border: 1Px solid #EBEDF1;
					}
					img {
						width: 92px;
					}
					.sign {
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						right: -4px;
						width: 60px;
					}
					.discounts {
						width: 48px;
						margin-left: 6px;
					}
				}
				.date {
					color: #A2A6AE;
					font-size: 13px;
					padding-top: 2px;
				}
				.card_num {
					padding-top: 15px;
					.money {
						padding-right: 44px;
						display: inline-block;
						&:last-of-type {
							padding-right: 0;
							p {
								&:first-of-type {
									font-size: 23px;
								}
							}
						}
						p {
							&:first-of-type {
								color: #292D37;
								font-size: 26px;
								font-weight: bold;
								span {
									font-size: 16px;
								}
							}
							&:last-of-type {
								color: #A2A6AE;
								font-size: 14px;
							}
						}
					}
					.time {
						padding-right: 53px;
					}
				}
			}
		}
		.order_form {
			padding: 0 15px;
			padding-top: 39px;
			.base_info, .work_info, .money_info {
				padding-bottom: 17px;
				background: #fff;
				border-radius: 4px;
				margin-bottom: 18px;
				.tit {
					position: relative;
					height: 54px;
					margin: 0 11px;
					border-bottom: 1Px solid #F6F6F6;
					display: flex;
					align-items: center;
					p {
						position: relative;
						color: #2B2F3A;
						font-size: 16px;
						font-weight: bold;
						img {
							position: absolute;
							bottom: 2px;
							left: -1px;
							width: 66px;
						}
					}
				}
				.item {
					padding: 0 17px;
					padding-top: 14px;
					display: flex;
					justify-content: space-between;
					span {
						&:first-of-type {
							color: #2B2F3A;
							font-size: 16px;
						}
						&:last-of-type {
							color: #7D8290;
							font-size: 16px;
						}
					}
				}

			}

		}
		.bottom{
			position: fixed;
			bottom: 0;
			left: 0;
			width: 100%;
			.van-button--primary {
				width: 100%;
				height: 46px;
				border-radius: 4px;
				border: 0;
				font-size: 16px;
				font-weight: bold;
				color: #FFFFFF;
				border-radius: 0;
				background: #3A5EEC;

			}
		}
		.buy_order {
			background: #fff;
			position: fixed;
			bottom: 0;
			left: 0;
			width: 100%;
			height: 46px;
			padding: 0 7px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			.price_num {
				position: relative;
				display: flex;
				justify-content: center;
				align-items: center;
				.num {
					font-size: 22px;
					font-weight: bold;
					color: #2B2F3A;
					padding-left: 6px;
					span {
						font-size: 16px;
						color: #575F72;
						font-weight: normal;
					}
				}

				i {
					font-style: normal;
					text-decoration:line-through;
					color: #575F72;

				}
				.sign {
					position: absolute;
					top: 0;
					right: -8px;
					transform: translateX(100%);
					width: 38px;
					height: 16px;
					line-height: 16px;
					background: #3A5EEC;
					color: #fff;
					font-size: 11px;
					text-align: center;
					border-radius: 10px;
					border-bottom-left-radius: 0;
					span {
						display: block;
						color: #fff;
						transform: scale(.9);
					}
				}

			}
			.van-button--primary {
				width: 191px;
				height: 36px;
				border-radius: 20px;
				border: 0;
				font-size: 16px;
				font-weight: bold;
				color: #FFFFFF;
				background: #3A5EEC;

			}

		}


		.dialog {
			position: fixed;
			z-index: 2001;
			left: 50%;
			top: 50%;
			transform: translate(-50%,-50%);
			width: 320px;
			height: 184px;
			background: #fff;
			border-radius: 8px;
			h4 {
				font-weight: bold;
				padding-top: 32px;
				text-align: center;
				font-size: 17px;
				color: #2B2F3A;
			}
			.primary {
				padding-top: 16px;
				text-align: center;
				color: #7D8290;
				font-size: 17px;
			}
			.primary_img_run {
				img {
					display: block;
					width: 90px;
					margin: 0 auto;
					margin-top: 23px;
				}
				p {
					padding-top: 22px;
					color: #7D8290;
					font-size: 17px;
					text-align: center;
				}

			}
			.primary_img_fail, .primary_img_success {
				img {
					display: block;
					width: 102px;
					margin: 0 auto;
					margin-top: 27px;
				}
				p {
					padding-top: 22px;
					color: #7D8290;
					font-size: 16px;
					text-align: center;
				}
			}
			.footer {
				position: absolute;
				bottom: 1px;
				left: 0;
				width: 100%;
				border-top: 1Px solid #eee;
				display: flex;
				height: 55px;
				align-items: center;
				p {
					text-align: center;
					font-size: 17px;
					font-weight: bold;
					height: 55px;
					line-height: 55px;
					flex: 1;
				}
				.left {
					color: #7D8290;
					border-right: 1PX solid #eee;
				}
				.right {
					color: #2B2F3A;
				}
			}
		}
		.primary_img_dialog_run {
			width: 232px;
		}
				
		.primary_img_dialog_success_fail {
			width: 275px;
			height: 282px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/orderInfo/Info.vue